'use client';

// Hook wrapper kept separate so server pages can import the pure fetchers
// from utils/affiliateData without dragging React hooks into RSC graphs.
import { useEffect, useState } from 'react';
import {
  getAffiliateMetadata,
  type AffiliateDetails,
} from './affiliateData';

export * from './affiliateData';

export const useAffiliateMetadata = (affiliateCode: string) => {
  const [affiliateDetails, setAffiliateDetails] =
    useState<AffiliateDetails | null>(null);
  useEffect(() => {
    const fetchAffiliateDetails = async () => {
      try {
        const affiliateData = await getAffiliateMetadata(
          affiliateCode as string,
        );
        if (affiliateData.status !== 'ok') {
          throw new Error(affiliateData.error.message ?? '');
        }

        setAffiliateDetails({
          name: affiliateData.data.name,
          code: affiliateData.data.code,
          image: affiliateData.data.image,
          m1Active: affiliateData.data.m1_active,
          ringActive: affiliateData.data.ring_active,
          ringProActive: affiliateData.data.ring_pro_active ?? affiliateData.data.ring_active,
          ringRareActive: affiliateData.data.ring_rare_active,
          ringDieselActive: affiliateData.data.ring_diesel_active,
          homeActive: affiliateData.data.home_active,
          bloodVisionActive: affiliateData.data.blood_vision_active,
          performanceLabsActive:
            affiliateData.data.performance_labs_active ?? false,
          subtitle: affiliateData.data.subtitle,
          landing_page: affiliateData.data.landing_page,
          discount_configs: affiliateData.data.discount_config,
          // Absent on older backends; default so PL resolution is a no-op
          // rather than a crash.
          performance_labs_discount_configs:
            affiliateData.data.performance_labs_discount_config ?? {},
        });
      } catch (e) {
        return {
          redirect: {
            destination: '/404',
          },
        };
      }
    };
    if (affiliateCode) fetchAffiliateDetails();
  }, [affiliateCode]);

  return { affiliateDetails };
};

